export default {
  'customers.domain.name': 'Name',
  'customers.domain.cpfCnpj': 'CPF/CNPJ',
  'customers.domain.rg': 'RG',
  'customers.domain.genderType': 'Gender Type',
  'customers.domain.genderType.man': 'Man',
  'customers.domain.genderType.woman': 'Woman',
  'customers.domain.genderType.genderless': 'Genderless',
  'customers.domain.birthDate': 'Birth Date',
  'customers.domain.maritalStatus': 'Marital Status',
  'customers.domain.maritalStatus.single': 'Single',
  'customers.domain.maritalStatus.married': 'Married',
  'customers.domain.maritalStatus.divorced': 'Divorced',
  'customers.domain.maritalStatus.widower': 'Widower',
  'customers.domain.profession': 'Profession',
  'customers.domain.nationality': 'Nationality',
  'customers.domain.fantasyName': 'Fantasy Name',
  'customers.domain.municipalRegistration': 'Municipal Registration',
  'customers.domain.stateRegistration': 'State Registration',
  'customers.domain.policyNumber': 'Policy Number',
  'customers.domain.michelinSegmentCode': 'Michelin Segment Code',
  'customers.domain.website': 'Web Site',
  'customers.domain.creditLimit': 'Credit Limit',
  'customers.domain.rentalCompany': 'Rental Company',
  'customers.domain.observation': 'Observation',
  'customers.domain.personType': 'Person Type',
  'customers.domain.personType.natural': 'Natural Person',
  'customers.domain.personType.legal': 'Legal Person',

  'customers.domain.address.description': 'Description',
  'customers.domain.address.street': 'Street',
  'customers.domain.address.number': 'Number',
  'customers.domain.address.zipCode': 'CEP',
  'customers.domain.address.district': 'District',
  'customers.domain.address.complement': 'Complement',
  'customers.domain.address.main': 'Main',
  'customers.domain.address.delivery': 'Delivery',

  'customers.domain.contact.contactType': 'Contact Type',
  'customers.domain.contact.contactType.email': 'E-Mail',
  'customers.domain.contact.contactType.mobile': 'Mobile',
  'customers.domain.contact.contactType.fax': 'Fax',
  'customers.domain.contact.contactType.phone': 'Phone',
  'customers.domain.contact.contactType.whatsapp': 'WhatsApp',
  'customers.domain.contact.name': 'Name',
  'customers.domain.contact.value': 'Contact',

  'customers.vehicle.accessory': 'Automotive accessories',
  'customer.vehicle.accessory.notifications.create.success.title':
    'Vehicle accessory successfully registered!',
  'customer.vehicle.accessory.notifications.create.success.description':
    'New accessory has been successfully registered.',
  'customer.vehicle.accessory.accessoryAlreadyExists':
    'This accessory already exists!',
  'customer.vehicle.accessory.error.delete.constraint':
    'Unable to delete an accessory linked to a vehicle!',

  'customer.vehicle.accessory.notifications.remove.title': 'Remove Accessory',
  'customer.vehicle.accessory.notifications.remove.content':
    'Do you really want to remove the Accessory?',

  'customer.vehicle.accessory.remove.notification.success.message':
    'Accessory Removed',
  'customer.vehicle.accessory.remove.notification.successDescription.description':
    'Accessory has been removed successfully!',

  'customers.domain.vehicle.createAccessory': 'Manage Automotive Accessories',
  'customers.domain.vehicle.accessory.description': 'Description',

  'customers.domain.vehicle.licensePlate': 'License Plate',
  'customers.domain.vehicle.licensePlate.invalidPlateError':
    'Invalid plate, must be in the AAA9999 or AAA9A99 formats.',
  'customers.domain.vehicle.brand': 'Brand',
  'customers.domain.vehicle.model': 'Model',
  'customers.domain.vehicle.version': 'Version',
  'customers.domain.vehicle.yearFabrication': 'Fabrication Year',
  'customers.domain.vehicle.yearModel': 'Model Year',
  'customers.domain.vehicle.yearModel.invalidError':
    'The model year have to be equal or greater than the fabrication year.',
  'customers.domain.vehicle.fuel': 'Fuel',
  'customers.domain.vehicle.fuel.alcohol': 'Alcohol',
  'customers.domain.vehicle.fuel.biodiesel': 'Biodiesel',
  'customers.domain.vehicle.fuel.diesel': 'Diesel',
  'customers.domain.vehicle.fuel.electric': 'Electric',
  'customers.domain.vehicle.fuel.flex': 'Flex',
  'customers.domain.vehicle.fuel.gasoline': 'Gasoline',
  'customers.domain.vehicle.fuel.gnv.alcohol': 'Gnv/Alcohol',
  'customers.domain.vehicle.fuel.gnv.flex': 'Gnv/Flex',
  'customers.domain.vehicle.fuel.gnv.gasoline': 'Gnv/Gasoline',
  'customers.domain.vehicle.fuel.hybrid': 'Hybrid',
  'customers.domain.vehicle.km': 'Avg. Km/Month',
  'customers.domain.vehicle.renavam': 'Renavam',
  'customers.domain.vehicle.chassi': 'Chassi',
  'customers.domain.vehicle.color': 'Color',
  'customers.domain.vehicle.color.beige': 'Beige',
  'customers.domain.vehicle.color.black': 'Black',
  'customers.domain.vehicle.color.blue': 'Blue',
  'customers.domain.vehicle.color.brown': 'Brown',
  'customers.domain.vehicle.color.gold': 'Golden',
  'customers.domain.vehicle.color.gray': 'Gray',
  'customers.domain.vehicle.color.green': 'Green',
  'customers.domain.vehicle.color.orange': 'Orange',
  'customers.domain.vehicle.color.pink': 'Pink',
  'customers.domain.vehicle.color.purple': 'Purple',
  'customers.domain.vehicle.color.red': 'Red',
  'customers.domain.vehicle.color.silver': 'Silver',
  'customers.domain.vehicle.color.white': 'White',
  'customers.domain.vehicle.color.yellow': 'Yellow',
  'customers.domain.vehicle.accessories': 'Accessories',
  'customers.domain.vehicle.color.grena': 'Grena',
  'customers.domain.vehicle.color.undefined': 'Undefined',
  'customers.domain.vehicle.color.fantasy': 'Fantasy',

  'customers.generalInfo': 'General Info',

  'customers.address': 'Address',
  'customers.address.create.notification.success': 'Success',
  'customers.address.create.notification.successDescription':
    'Address created.',

  'customers.address.update.notification.success': 'Success',
  'customers.address.update.notification.successDescription':
    'Address updated.',

  'customers.address.remove': 'Remove Address',
  'customers.address.remove.alert': 'Do you really want to remove the address?',
  'customers.address.remove.notification.success': 'Success',
  'customers.address.remove.notification.successDescription':
    'Address removed.',

  'customers.contact': 'Contact',
  'customers.contact.create.notification.success': 'Success',
  'customers.contact.create.notification.successDescription':
    'Contact created.',

  'customers.contact.update.notification.success': 'Success',
  'customers.contact.update.notification.successDescription':
    'Contact updated.',

  'customers.contact.remove': 'Remove Contact',
  'customers.contact.remove.alert': 'Do you really want to remove the contact:',
  'customers.contact.remove.notification.success': 'Success',
  'customers.contact.remove.notification.successDescription':
    'Contact removed.',

  'customers.domain.vehicle.create': 'New Vehicle',
  'customers.vehicle': 'Vehicle',
  'customers.vehicle.create.notification.success': 'Success',
  'customers.vehicle.create.notification.successDescription':
    'Vehicle created.',

  'customers.vehicle.update.notification.success': 'Success',
  'customers.vehicle.update.notification.successDescription':
    'Vehicle updated.',

  'customers.vehicle.remove': 'Remove Vehicle',
  'customers.vehicle.remove.confirm.title': 'Remove Vehicle',
  'customers.vehicle.remove.confirm.content':
    'Do you really want to remove the vehicle:',
  'customers.vehicle.remove.success.message': 'Success',
  'customers.vehicle.remove.success.description': 'Vehicle removed.',

  'customers.simplifiedRegister': 'Simplified Customer Register',

  'customers.vehicle.simplifiedRegister':
    'Simplified Customer Vehicle Register',

  'customers.modal.report.title': 'Generate Report',
  'customers.modal.report.buttons.viewReport': 'View Report',
  'customers.modal.report.buttons.pdf': 'Generate PDF',
  'customers.modal.report.buttons.rtf': 'Generate RTF',
  'customers.modal.report.buttons.csv': 'Generate CSV',
  'customers.modal.report.form.type': 'Type',
  'customers.modal.report.form.situation': 'Situation',
  'customers.modal.report.form.state': 'State',
  'customers.modal.report.form.city': 'City',
  'customers.modal.report.form.birthdayOf': 'Birthday Of',
  'customers.modal.report.form.upUntil': 'Up Until',
  'customers.modal.report.form.inclusionData': 'Inclusion Date Of',
  'customers.modal.report.form.sex': 'Sex',
  'customers.modal.report.form.vehicleBrand': 'Brand',
  'customers.modal.report.form.vehicleModel': 'Model',
  'customers.notification.generate.report.title':
    'Report Generated Successfully',
  'customers.notification.generate.report.description':
    'Successfully Generated Customer Report!',

  'customers.list.newCustomer': 'Create New Customer',
  'customers.list.header.name': 'Name',
  'customers.list.header.fantasyName': 'Fantasy Name',
  'customers.list.header.cpfCnpj': 'CPF/CNPJ',
  'customers.list.header.email': 'E-Mail',
  'customers.list.header.phone': 'Phone',
  'customers.list.header.numberPlate': 'Number Plate',
  'customers.list.header.includedAt': 'Included At',
  'customers.list.header.actions': 'Actions',
  'customers.list.header.actions.button': 'View/Edit',
  'customers.details.generalInfo.form.individual': 'Individual',
  'customers.details.generalInfo.form.corporation': 'Corporation',
  'customers.details.generalInfo.form.name': 'Name',
  'customers.details.generalInfo.form.cpfCnpj': 'CPF/CNPJ',
  'customers.details.generalInfo.form.rg': 'RG',
  'customers.details.generalInfo.form.gender': 'Gender',
  'customers.details.generalInfo.form.maritalStatus': 'Marital Status',
  'customers.details.generalInfo.form.nationality': 'Nationality',
  'customers.details.generalInfo.form.fantasyName': 'Fantasy name',
  'customers.details.generalInfo.form.municipalRegistration':
    'Municipal registration',
  'customers.details.generalInfo.form.stateRegistration': 'State Registration',
  'customers.details.generalInfo.form.website': 'Web Site',
  'customers.details.generalInfo.form.creditLimit': 'Credit limit',
  'customers.details.generalInfo.form.birthDate': 'Birth Date',
  'customers.details.generalInfo.form.email': 'E-Mail',
  'customers.details.generalInfo.form.phone1': 'Phone 1',
  'customers.details.generalInfo.form.phone2': 'Phone 2',
  'customers.details.generalInfo.form.profession': 'Profession',
  'customers.details.generalInfo.form.meetingMethod': 'How did you find us?',
  'customers.details.generalInfo.form.billingAddress': 'Address',
  'customers.details.generalInfo.form.cep': 'CEP',
  'customers.details.generalInfo.form.street': 'Street Name',
  'customers.details.generalInfo.form.number': 'Number',
  'customers.details.generalInfo.form.complement': 'Complement',
  'customers.details.generalInfo.form.district': 'District',
  'customers.details.generalInfo.form.city': 'City',
  'customers.details.generalInfo.form.state': 'State',
  'customers.details.generalInfo.form.addAddress': 'Add Address',
  'customers.details.generalInfo.form.obs': 'Observations',
  'customers.details.generalInfo.form.rentalCompany': 'Car rental company?',
  'customers.details.generalInfo.form.genderType.man': 'Man',
  'customers.details.generalInfo.form.genderType.woman': 'Woman',
  'customers.details.generalInfo.form.maritalStatus.single': 'Single',
  'customers.details.generalInfo.form.maritalStatus.married': 'Married',
  'customers.details.generalInfo.form.maritalStatus.divorced': 'Divorced',
  'customers.details.generalInfo.form.maritalStatus.widower': 'Widower',
  'customers.details.generalInfo.form.publicAgency': 'Public agency',
  'customers.details.generalInfo.form.issRetention':
    'Will there be retention of ISS for this customer?',
  'customers.details.generalInfo.form.irpjOrCsllRetention':
    'Will there be retention of IRPJ/CSLL for this customer?',
  'customers.details.generalInfo.form.enableLgpd':
    'Does the customer authorizes the GDPR data usage?',
  'customers.details.generalInfo.form.enableAlert':
    'Not showing GDPR alert when editing or saving budget?',
  'customers.details.generalInfo.form.crm':
    'CRM - Customer relationship management',
  'customers.details.generalInfo.form.whatsapp': 'WhatsApp',
  'customers.details.generalInfo.form.sms': 'SMS',
  'customers.filters.active': 'Active',
  'customers.filters.active.options.all': 'All',
  'customers.filters.active.options.active': 'Active',
  'customers.filters.active.options.inactive': 'Inactive',
  'customers.filters.cpfCnpj': 'CPF/CNPJ',
  'customers.filters.fantasyName': 'Fantasy name',
  'customers.filters.genderType': 'Gender',
  'customers.filters.genderType.options.man': 'Man',
  'customers.filters.genderType.options.woman': 'Woman',
  'customers.filters.licensePlate': 'License Plate',
  'customers.filters.personType': 'Person Type',
  'customers.filters.personType.options.natural': 'Natural',
  'customers.filters.personType.options.legal': 'Legal',
  'customers.filters.order': 'Order by',
  'customers.filters.order.options.asc': 'Asc',
  'customers.filters.order.options.desc': 'Desc',

  'customers.notifications.create.success.title':
    'Customer registered successfully!',
  'customers.notifications.create.success.description':
    'The new customer has been registered successfully.',

  'customer.status.message': 'Customer Status successfully changed!',

  'customers.notifications.create.error.title':
    'Error registering the customer!',
  'customers.notifications.create.error.description':
    'An error occurred when registering customers. Please check the fields and try again.',

  'customers.notifications.update.success.title':
    'Customer updated successfully!',
  'customers.notifications.update.success.description':
    'Customer information has been successfully updated.',

  'customers.notifications.update.error.title': 'Error updating customer!',
  'customers.notifications.update.error.description':
    'An error occurred while updating the customer. Please check the fields and try again.',

  'customers.notifications.remove.success.title':
    'Customer successfully removed!',
  'customers.notifications.remove.success.description':
    'The customer was successfully removed from the system.',

  'customers.notifications.remove.error.title': 'Error removing customer!',
  'customers.notifications.remove.error.description':
    'An error occurred while trying to remove the customer.',

  'customers.notifications.remove.confirm.title':
    'Do you really want to delete this customer?',
  'customers.notifications.remove.confirm.content':
    'By removing the customer, all of their information will be permanently lost. Still want to continue?',
  'customers.notifications.remove.confirm.okText': 'Remove customer',
  'customers.notifications.remove.confirm.cancelText': 'Cancel',

  'customers.modal.selectedCustomers.title.add': 'Add Customer',
  'customers.modal.selectedCustomers.search': 'Search for Customers',

  'customers.form.button.recommendation.create': 'Create',
  'customers.list.recommendation': 'Recommendation',
  'customers.form.recommendation': 'How did you meet us?',
  'customers.form.recommendation.description': 'Description',
  'customers.form.recommendation.create.success':
    'Recommendation created successfully!',
  'customers.form.recommendation.update.success':
    'Recommendation successfully edited!',
  'customers.recommendation.notifications.remove.confirm.title':
    'Do you really want to delete this indication?',
  'customers.recommendation.notifications.remove.confirm.content':
    'When removing the nomination, the nomination will be permanently deleted. Do you still want to continue?',
  'customers.form.recommendation.delete.success':
    'Recommendation successfully deleted!',
  'customers.form.button.recommendation.update.modal.title':
    'Edit Recommendation',
  'customers.form.recommendation.create.error.duplicate.description':
    'Recommendation already created with this description.',
  'customer.recommendation.error.delete.constraint':
    'It is not possible to delete a recommendation that is linked',
};
